import client from './main-client';

export const getTerritoriesApi = (params) => client()
  .get('/options-territories', { params });
